"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../Theme/constant");
var _constant2 = require("../constant");
var _button = _interopRequireDefault(require("../Button/button.proptypes"));
var _constant3 = require("./constant");
var _default = {
  PropTypes: {
    headingText: _propTypes.default.string.isRequired,
    mainText: _propTypes.default.string.isRequired,
    textAfterBulletPoints: _propTypes.default.oneOf([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
    bulletText: _propTypes.default.arrayOf(_propTypes.default.string),
    buttonTextLearnMore: _propTypes.default.string,
    buttonTextOk: _propTypes.default.string,
    handleClick: _propTypes.default.func,
    handleLearnMore: _propTypes.default.func,
    handleCloseClick: _propTypes.default.func,
    redirectionURL: _propTypes.default.string,
    customProperties: _propTypes.default.object,
    target: _propTypes.default.oneOf(Object.keys(_constant3.TARGET)),
    viewPort: _propTypes.default.string,
    openModal: _propTypes.default.bool,
    accessibility: _propTypes.default.bool,
    theme: _propTypes.default.string,
    showCloseIcon: _propTypes.default.bool,
    hasImage: _propTypes.default.bool,
    imageConfig: _propTypes.default.shape({
      imageURL: _propTypes.default.string,
      imageHeight: _propTypes.default.string,
      imageWidth: _propTypes.default.string
    }),
    secondaryButtonProps: _propTypes.default.shape(_button.default.PropTypes),
    mainParaText: _propTypes.default.object,
    bulletParaText: _propTypes.default.object,
    paraAfterBulletPoints: _propTypes.default.object,
    isStickyBtn: _propTypes.default.bool,
    airAsiaPlusProps: _propTypes.default.object
  },
  DefaultProps: {
    headingText: 'Self-transfer during layover',
    /* eslint-disable max-len */
    mainText: "If you have a self-transfer in your trip, your connections are not covered by the carriers. We combine separate flights, trains, or buses to offer you more options and better deals. Our Kiwi.com Guarantee protects all self-transfers. You might need to leave the transit zone at the transfer airport and go through security and customs again. Here's why:\n " + '• Recheck baggage between flights\n' + '• Check in for your next flight\n' + '• Immigration\n' + 'Transfer between different airport terminals. ',
    buttonTextOk: 'OK',
    accessibility: true,
    theme: _constant.DEFAULT_THEME,
    viewPort: _constant2.DEVICE_TYPE.DESKTOP,
    openModal: true,
    showCloseIcon: false,
    hasImage: false,
    isStickyBtn: false,
    airAsiaPlusProps: {
      content: []
    }
  }
};
exports.default = _default;